import { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Download, X } from 'lucide-react';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Check if already installed or dismissed
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    if (sessionStorage.getItem('pwa-dismissed')) return;

    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(ios);

    if (ios && !navigator.standalone) {
      const timer = setTimeout(() => setShowPrompt(true), 5000);
      return () => clearTimeout(timer);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setTimeout(() => setShowPrompt(true), 3000);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShowPrompt(false);
    setDeferredPrompt(null);
  };

  const dismiss = () => {
    setShowPrompt(false);
    sessionStorage.setItem('pwa-dismissed', 'true');
  };

  if (!showPrompt) return null;

  return (
    <div data-testid="install-prompt" className="fixed bottom-20 lg:bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 z-50 bg-white rounded-xl border border-[#E4E4E7] shadow-xl p-4 animate-fade-up">
      <button onClick={dismiss} className="absolute top-3 right-3 text-[#A1A1AA] hover:text-[#52525B]"><X className="w-4 h-4" /></button>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-[#0052FF] flex items-center justify-center flex-shrink-0"><Download className="w-5 h-5 text-white" /></div>
        <div className="flex-1">
          <p className="text-sm font-bold text-[#0A0A0A]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Instalar Ciudad Inteligente</p>
          {isIOS ? (
            <p className="text-xs text-[#52525B] mt-1 leading-relaxed">Toca <span className="font-semibold">Compartir</span> y luego <span className="font-semibold">Agregar a pantalla de inicio</span></p>
          ) : (
            <>
              <p className="text-xs text-[#52525B] mt-1">Accede desde tu pantalla de inicio</p>
              <Button data-testid="install-btn" onClick={handleInstall} className="mt-2 h-8 text-xs bg-[#0052FF] hover:bg-[#0040CC] text-white rounded-md font-bold w-full">Instalar</Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
